import React from "react"

export default function SectionTitle({
  subtitle,
  title,
  description,
  center = true,
  light = false,
}) {
  return (
    <div
      className={`max-w-3xl ${
        center ? "mx-auto text-center" : "text-left"
      }`}
    >
      {/* Subtitle */}
      {subtitle && (
        <span
          className={`inline-block text-sm md:text-base uppercase tracking-[4px] font-medium mb-4 ${
            light ? "text-[#d6b57b]" : "text-[#b8955d]"
          }`}
        >
          {subtitle}
        </span>
      )}

      {/* Title */}
      {title && (
        <h2
          className={`text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight ${
            light ? "text-white" : "text-[#111111]"
          }`}
        >
          {title}
        </h2>
      )}

      {/* Decorative Line */}
      <div
        className={`w-24 h-[2px] mt-6 ${
          center ? "mx-auto" : ""
        } ${light ? "bg-[#d6b57b]" : "bg-[#b8955d]"}`}
      />

      {/* Description */}
      {description && (
        <p
          className={`mt-6 text-base md:text-lg leading-relaxed ${
            light ? "text-gray-300" : "text-gray-600"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  )
}